var _path, _rect, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.4445H18V14C18 15.8856 18 16.8284 17.4142 17.4142C16.8284 18 15.8856 18 14 18H5C3.11438 18 2.17157 18 1.58579 17.4142C1 16.8284 1 15.8856 1 14V10.4445Z",
    fill: "#B0D2D0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 17,
    height: 17,
    rx: 2,
    stroke: "#17A398",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0142 5L6.59998 6.46325L10.0142 7.92649L13.4285 6.46325L10.0142 5Z",
    stroke: "#17A398",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57303 8.19316L6.36365 8.71147C6.14304 8.80601 6 9.02294 6 9.26295C6 9.50297 6.14304 9.71989 6.36365 9.81444L9.77789 11.2777C9.92882 11.3424 10.0997 11.3424 10.2506 11.2777L13.6648 9.81444C13.8854 9.71989 14.0285 9.50297 14.0285 9.26295C14.0285 9.02294 13.8854 8.80601 13.6648 8.71147L12.4554 8.19316L10.9323 8.84594L11.9053 9.26295L10.0142 10.0734L8.12315 9.26295L9.09618 8.84594L7.57303 8.19316ZM9.79464 7.24134C9.93576 7.18583 10.0927 7.18583 10.2338 7.24134L10.0142 7.33545L9.79464 7.24134Z",
    fill: "#17A398"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57303 10.9915L6.36365 11.5098C6.14304 11.6044 6 11.8213 6 12.0613C6 12.3013 6.14304 12.5182 6.36365 12.6128L9.77789 14.076C9.92882 14.1407 10.0997 14.1407 10.2506 14.076L13.6648 12.6128C13.8854 12.5182 14.0285 12.3013 14.0285 12.0613C14.0285 11.8213 13.8854 11.6044 13.6648 11.5098L12.4554 10.9915L10.9323 11.6443L11.9053 12.0613L10.0142 12.8718L8.12315 12.0613L9.09618 11.6443L7.57303 10.9915ZM9.79464 10.0397C9.93576 9.98417 10.0927 9.98417 10.2338 10.0397L10.0142 10.1338L9.79464 10.0397Z",
    fill: "#17A398"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/AIIcon.6ca8c99a47d394b44d6c8517f15aa7d2.svg";
export { ForwardRef as ReactComponent };